export default {
  home: {
    name: '亚洲航空',
  },
};
